// This function changes the class on the header when the user scrolls 15% of the viewport and 

export function menuBG() {

    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();    
        if (scroll >= 0.10 * $(window).height()) {
            $(".main-nav").addClass('solid-bg');
        } else {
            $(".main-nav").removeClass('solid-bg');
        }
    });

}